// Модуль загрузки скрипта виджета группы ВКонтакте

import {observeIntersection} from 'src/assets/js/utils/observe-intersection';

app.modules.vkWidgetGroup = (function (self) {
  const CONFIG = app.config.vkWidgetGroup;
  let _intersectionObserver;

  function _initObserver() {
    _intersectionObserver = observeIntersection(
      '.js-vk-widget-container',
      _loadAndInitVkWidget,
      {
        rootMargin: '500px 0px 500px 0px',
      }
    );
  }

  function _loadAndInitVkWidget() {
    _intersectionObserver.disconnect();

    const script = document.createElement('script');

    script.src = '//vk.com/js/api/openapi.js?101';
    script.defer = true;
    document.body.appendChild(script);

    script.onload = function () {
      window.VK.Widgets.Group(
        'vk_groups',
        {
          no_cover: CONFIG.noCover,
          mode: CONFIG.mode,
          width: CONFIG.width,
          height: CONFIG.height,
          color1: CONFIG.color1,
          color2: CONFIG.color2,
          color3: CONFIG.color3,
        },
        CONFIG.id
      );

      if (!CONFIG.gaEvent.length) return;
    };
  }

  function _init() {
    if (!CONFIG) return;

    _initObserver();
  }

  self.load = _init;
  return self;
})(app.modules.vkWidgetGroup || {});
